/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './landing.stache';
import can from 'can';
import Swiper from 'swiper';
import cloudinaryUtil from 'scripts/utils/cloudinary';

Component.extend({
    tag: 'history-experience-collections-landing',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            collections: {
                Type: can.List,
                Value: can.List,
            },
        },
    },
    events: {
        inserted() {
            this.initSlider();
        },

        initSlider() {
            if (!this.element.find('.swiper-slide').length) {
                return;
            }

            this.swiper = new Swiper('.s-history-collections-content', {
                direction: 'horizontal',
                spaceBetween: 20,
                centeredSlides: false,
                slidesPerView: 'auto',
                simulateTouch: true,
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 3,
                },
                watchSlidesVisibility: true,
            });

            this.swiper.on('lazyImageReady', () => this.swiper.update());
        },

        '.s-history-collections-list__item click'(element, event) {
            if (this.swiper.animating) {
                event.preventDefault();
            }
        },
    },
    helpers: {
        collectionTag(options) {
            const tag = options.context['tag'];
            return tag ? tag.toLowerCase().replace(' ', '-') : null;
        },
    },
});
